import { CATEGORIES } from "$src/core/services/search-classification/constants";
import { resolveWithTransformations } from "$src/core/services/search-classification/static-lookup/utils";
import type {
  ClassificationDefinition,
  ClassificationResult,
  SearchClassificationMode,
  SearchClassificationService,
  SearchClassificationStatus,
} from "$src/core/services/search-classification/types";
import { classifyQuery } from "$src/core/services/search-classification/utils";
import Storage from "$src/core/services/storage/storage";

const definition: ClassificationDefinition = {
  categories: [...CATEGORIES],
};

const resolveTerms = resolveWithTransformations(definition);

const isEnabled = (): boolean =>
  Storage.get("search.conversational.status") === "enabled";

const classify = async (
  query: string,
): Promise<ClassificationResult | null> => {
  if (!isEnabled()) return null;
  return classifyQuery(query, definition, resolveTerms);
};

const StaticLookup: SearchClassificationService = {
  // Nothing to detect and nothing to download: it is supported everywhere
  isSupported: true,
  get mode(): SearchClassificationMode | null {
    return isEnabled() ? "static-lookup" : null;
  },
  get status(): SearchClassificationStatus | null {
    return isEnabled() ? "available" : null;
  },
  classify,
};

export default StaticLookup;
